import { useEffect, useState } from 'react';
import api from '@/lib/api';

export function VideosPage() {
    const [videos, setVideos] = useState<any[]>([]);
    const [currentVideo, setCurrentVideo] = useState<any>(null);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
            const res = await api.get('/videos/');
                setVideos(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchVideos();
    }, []);

    return (
        <div className="min-h-screen bg-gray-50 p-8">
            <div className="max-w-4xl mx-auto space-y-6">
                <header className="flex justify-between items-center bg-white p-6 rounded-lg shadow-sm">
                    <h1 className="text-2xl font-bold text-gray-900">Maison Theater</h1>
                </header>

                {currentVideo && (
                    <div className="bg-black rounded-lg overflow-hidden shadow-lg aspect-video">
                        <video
                            controls
                            autoPlay
                            className="w-full h-full"
                            src={`/api/videos/${currentVideo.video_id}/stream`}
                        >
                            Your browser does not support the video tag.
                        </video>
                        <div className="p-4 bg-gray-900 text-white">
                            <h2 className="text-xl font-bold">{currentVideo.title || 'Untitled Video'}</h2>
                        </div>
                    </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {videos.length === 0 && <p className="col-span-3 text-center text-gray-500">No videos available.</p>}
                    {videos.map(video => (
                        <div
                            key={video.video_id}
                            className="bg-white p-4 rounded-lg shadow-sm cursor-pointer hover:shadow-md transition-all"
                            onClick={() => setCurrentVideo(video)}
                        >
                            <div className="aspect-video bg-gray-200 rounded mb-2 flex items-center justify-center">
                                <span className="text-4xl">▶️</span>
                            </div>
                            <h3 className="font-semibold">{video.title || 'Untitled'}</h3>
                            <p className="text-xs text-gray-500">Video ID: {video.video_id}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
